import { BsUpcScan } from "react-icons/bs";
import { useContext, useEffect, useState } from "react";
import { ScannerContext } from "../../store/ScannerContextProvider";
import { scannerInputToolTipErrorInformationsCard, scannerInputToolTipInformationsCard } from "../../utils/messagesUtils";
import ScannerInput from "../ScannerInput/ScannerInput";
import InfoIcon from "@mui/icons-material/Info";
import CustomIcon from "../CustomIcon/CustomIcon";
import HoverToolTip from "../ToolTips/HoverToolTip/HoverToolTip";
import ControlledToolTip from "../ToolTips/ControlledToolTip/ControlledToolTip";
import * as Styles from "./ScannerInputActionBox.styles";

const DEFAULT_OPEN_CLOSE_INTERVAL = 3000;

export default function ScannerInputActionBox() {
  const { scannedCode, handleInputChange, handleKeyDown, isScannedCodeValid, keyDownEventCount } = useContext(ScannerContext);
  const [isErrorActive, setIsErrorActive] = useState(false);

  useEffect(() => {
    if (!isScannedCodeValid) {
      setIsErrorActive(true);

      const hideErrorTimeout = setTimeout(() => {
        setIsErrorActive(false);
      }, DEFAULT_OPEN_CLOSE_INTERVAL);

      return () => clearTimeout(hideErrorTimeout);
    }

    setIsErrorActive(false);
  }, [isScannedCodeValid, keyDownEventCount]);

  return (
    <ControlledToolTip
      color="var(--color-error-dark)"
      backgroundColor="var(--color-error-lighter)"
      content={scannerInputToolTipErrorInformationsCard}
      open={isErrorActive}
    >
      <Styles.ScannerPaper elevation={2} hasError={isErrorActive}>
        <Styles.IconContainer>
          <CustomIcon Icon={BsUpcScan} />
        </Styles.IconContainer>

        <ScannerInput onChange={handleInputChange} value={scannedCode} onKeyDown={handleKeyDown} />

        <HoverToolTip content={scannerInputToolTipInformationsCard}>
          <Styles.IconContainer>
            <CustomIcon Icon={InfoIcon} color={"var(--color-primary"} hoverColor={"var(--color-secondary"} />
          </Styles.IconContainer>
        </HoverToolTip>
      </Styles.ScannerPaper>
    </ControlledToolTip>
  );
}
